import { useFormikContext } from 'formik'
import { FormEvent } from 'react'
import { PaymentInputsContainer } from 'react-payment-inputs'
import images from 'react-payment-inputs/images'


interface iCreditCardInputProps{
    name: string
    text: string
    placeholder?: string

}
interface iPaymentInputsProps{
    meta:any,
    getCardNumberProps: any
    getExpiryDateProps: any
    getCVCProps: any 
    getCardImageProps: any
}

export default function CreditCardInput({name, text}:iCreditCardInputProps) {

    const {setFieldValue, setFieldTouched} = useFormikContext()
    
    
    const handleInputOnChange = (field_name:string, data:string)=>{
        setFieldValue(field_name, data)
        setFieldTouched(field_name)
    }
    

    return (
        <div
            className="duration-300 w-full"
        >
            {/* @ts-ignore */}
            <PaymentInputsContainer>
                {({ meta, getCardNumberProps, getExpiryDateProps, getCVCProps, getCardImageProps }:iPaymentInputsProps) => (
                    <>
                        <label className='mb-1 flex flex-row text-left justify-between font-medium text-graphite_x2' htmlFor={name}
                        >
                            {text}
                            {(meta.isTouched && meta.error) && <span className="w-2 h-2 bg-error rounded-full inline-block"/>}
                        </label>
                        
                        <div className="bg-secondary2 px-4 w-full rounded focus-within:bg-primary focus-within:text-light_col">
                            <svg className='inline mr-2' {...getCardImageProps({images})} />
                            <input
                                {...getCardNumberProps({ onChange: ({currentTarget}:FormEvent<HTMLInputElement>)=>handleInputOnChange("card_number", currentTarget.value)})}  
                                className='w-48 py-4 bg-transparent outline-none'
                            />
                            <input 
                                {...getExpiryDateProps({onChange: ({currentTarget}:FormEvent<HTMLInputElement>)=>handleInputOnChange("card_expiry_date", currentTarget.value)})} 
                                className='w-16 py-4 bg-transparent outline-none'
                            />
                            <input 
                                {...getCVCProps({onChange: ({currentTarget}:FormEvent<HTMLInputElement>)=>handleInputOnChange("card_cvc", currentTarget.value)})}  
                                className='w-16 py-4 bg-transparent outline-none'
                            />
                        </div>
                    </>
                )}
            </PaymentInputsContainer>
        </div>
    )
}
